import React from 'react'

import Base from '../_Base'

const Notification = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M4.382 18 6 15.274V11c0-4.252 2.355-7 6-7s6 2.748 6 7v4.274L19.62 18H4.382zM12 21a1.993 1.993 0 0 1-1.722-1h3.444c-.347.595-.985 1-1.722 1zm9.806-3.234L20 14.726V11c0-5.299-3.29-9-8-9s-8 3.701-8 9v3.726L2.16 17.829a1.488 1.488 0 0 0 .066 1.459A1.49 1.49 0 0 0 3.502 20h4.64c.448 1.721 2 3 3.859 3s3.41-1.279 3.859-3h4.64c.525 0 1.002-.267 1.278-.713.275-.446.298-.992.029-1.521z"
      fillRule="evenodd"
    />
  </Base>
)

export default Notification
